import React from 'react';

import InvoicePresenter from '../../../../../presenters/store/InvoicePresenter';

import InvoiceCell from './components/InvoiceCell';

const InvoiceTable = ({ invoices, brand, onDialogOpen, onMarkAsPaid }) => {
  return (
    <table className="tables">
      <thead>
        <tr>
          <th>Invoice no.</th>
          <th>Period</th>
          <th>Due amount</th>
          <th>State</th>
          <th>Links</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {invoices.map((invoice) => (
          <InvoiceCell
            key={InvoicePresenter.id(invoice)}
            invoice={invoice}
            onDialogOpen={onDialogOpen}
            brand={brand}
            onMarkAsPaid={onMarkAsPaid}
          />
        ))}
      </tbody>
    </table>
  );
};

export default InvoiceTable;
